import React from 'react';
import Header from './widgets/Header';
import SurveyImage5 from '../../../assets/images/survey-image-5.png'
import LandingForm from './widgets/LandingForm';
import Media from './widgets/Media';

export default function SimpleFormLandingPage() {

    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">
                <div className="banner-section simple-form-landing-page pt-0">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="banner-text d-none">
                                    <h1 className='heading fs-48 fw-700'><span className='text-primary'>Digital Maturity Survey</span> Fusce in neque at ex condimentum </h1>
                                    <div className="text-part">
                                        <p>esent aliquam tellus nibh, vitae pretium elit tincidunt sit amet. Phasellus hendrerit luctus aliquet. Integer id turpis dui. Fusce in neque at ex condimentum viverra in at nisl. Integer ultrices ligula eget felis faucibus, sit amet pulvinar enim elementum.</p>
                                    </div>
                                    <div className="button-wrap">
                                        <a href="#0" className='btn btn-primary'>Start assessment</a>
                                    </div>
                                </div>
                                <LandingForm />
                            </div>
                            <div className="col-lg-6">
                                <div className="img-wrapper">
                                    <Media imageUrl={SurveyImage5} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
